import { useMemo } from 'react'
import { FieldType, Column, Table, Section } from '../../../../features/ui'
import { FiscalDocumentItem } from '../../state/types'

type Props = {
    items: FiscalDocumentItem[]
}

export const FiscalDocumentItemTable = (props: Props) => {
    const { items } = props

    const columns: Column[] = useMemo(() => [
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Producto'
        },
        {
            name: 'quantity',
            type: FieldType.NUMBER,
            label: 'Cantidad'
        },
        {
            name: 'unitSubtotal',
            type: FieldType.PRICE,
            label: 'Precio sin IVA'
        }
    ], [items])

    const rows = useMemo(() => items.map((item, index) => ({
        ...item,
        index
    })), [items])

    return (
        <Section id="itemPriceOutlineTable" space={12}>
            <Table
                columns={columns}
                rows={rows}
                rowId="index"
                alignRight
                readOnly
            />
        </Section>
    )
}
